export const usd = (n: number | null | undefined, compact = false) =>
  n == null ? "—" : new Intl.NumberFormat("en-US", {
    style: "currency", currency: "USD",
    notation: compact ? "compact" : "standard",
    maximumFractionDigits: compact ? 1 : 0,
  }).format(n);

export const money = (n: number | null | undefined, currency = "USD", dp = 2) =>
  n == null ? "—" : new Intl.NumberFormat("en-US", {
    style: "currency", currency, minimumFractionDigits: dp, maximumFractionDigits: dp,
  }).format(n);

export const num = (n: number | null | undefined, dp = 0) =>
  n == null ? "—" : new Intl.NumberFormat("en-US", { maximumFractionDigits: dp }).format(n);

export const pct = (n: number | null | undefined, dp = 1) =>
  n == null ? "—" : `${(n * 100).toFixed(dp)}%`;

/** Dates are calendar dates; parse as local so "2026-09-14" never shows as the 13th. */
export const day = (iso: string | null | undefined) => {
  if (!iso) return "—";
  const d = /^\d{4}-\d{2}-\d{2}$/.test(iso) ? new Date(`${iso}T00:00:00`) : new Date(iso);
  return d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
};

export const when = (iso: string | null | undefined) =>
  !iso ? "—" : new Date(iso).toLocaleString("en-GB", {
    day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
  });

export const monthLabel = (ym: string) => {
  const [y, m] = ym.split("-").map(Number);
  return new Date(y, m - 1, 1).toLocaleDateString("en-GB", { month: "short", year: "2-digit" });
};

export const titleCase = (s: string | null | undefined) =>
  !s ? "—" : s.replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase());
